module.exports = __webpack_public_path__ + "static/media/NotFoundChar-Mobile.43bacfcf.png";